/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { useField, useFormikContext } from 'formik';
import { Input } from 'syngenta-digital-cropwise-react-ui-kit';

const FormikInput = ({
  name,
  id = null,
  label = null,
  mask = null,
  ...rest
}) => {
  const [{ value, onBlur }, { error, touched }, { setValue }] = useField(name);
  const { submitCount } = useFormikContext();

  const showError = Boolean((touched || submitCount) && error);

  // A global or sticky regex carries lastIndex between calls, which would make
  // the same keystroke pass or fail depending on the previous one.
  const maskPattern = useMemo(
    () =>
      mask ? new RegExp(mask.source, mask.flags.replace(/[gy]/g, '')) : null,
    [mask]
  );

  const handleChange = event => {
    if (maskPattern && !maskPattern.test(event.target.value)) {
      return;
    }
    setValue(event.target.value);
  };

  return (
    <div>
      <Input
        id={id || kebabCase(name)}
        name={name}
        label={label}
        value={value}
        onBlur={onBlur}
        onChange={handleChange}
        status={showError ? 'error' : undefined}
        {...rest}
      />
      <div className="organizations-formik-input__error">
        {showError ? error : ''}
      </div>
    </div>
  );
};

FormikInput.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
  mask: PropTypes.instanceOf(RegExp)
};

export default FormikInput;
